module.exports = __webpack_public_path__ + "img/38.43f00554.png";